import React, { FunctionComponent } from "react";
import createSvgIcon from "@mui/icons-material/utils/createSvgIcon";

// SVG taken from https://materialdesignicons.com/icon/arrow-expand-horizontal
export default createSvgIcon(
	<path d="M9,11H15V8L19,12L15,16V13H9V16L5,12L9,8V11M2,20V4H4V20H2M20,20V4H22V20H20Z" fill="currentColor" />
	, "ArrowExpandHorizontal",
);

